$(() => {
    const $sideContact = $('.side-contact');
    const $button = $sideContact.find('.button');
    const $hamburger = $sideContact.find('.hamburger');

    const switchOpen = (e) => {
        e.preventDefault();
        if ($sideContact.hasClass('open')) {
            $sideContact.removeClass('open');
        } else {
            $sideContact.addClass('open');
        }
    };

    if ($sideContact.length) {
        $button.on( 'click', (e) => {
            switchOpen(e);
        });
        $hamburger.on( 'click', (e) => {
            switchOpen(e);
        });
    }
});
